import React, { useState } from 'react'
import LeaderBoard from '../component/Reports/LeaderBoard'
import SalesLeaderBoard from '../component/Reports/SalesLeaderBoard'

export default function Home() {
  const now = new Date().toLocaleDateString()
  const [activeTab, setActiveTab] = useState('stores')
  
  return (
    <>
        <div className='container'>
          <div className='row no-gutters'>
            <div  className='w-100' style={{ borderRadius: 4,padding: 20, border: '0px solid #adadad', boxShadow: '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)'}}>
              <h1 className='text-center'>FFUN Group Leader Board</h1>
              <p className='text-center'>last update: {now}</p>
              
              {/* Tab Navigation */}
              <div style={{ marginBottom: '0' }}>
                <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '0' }}>
                  <button 
                    onClick={() => setActiveTab('stores')}
                    style={{
                      padding: '12px 24px',
                      border: '1px solid #e0e0e0',
                      borderBottom: activeTab === 'stores' ? '1px solid white' : '1px solid #e0e0e0',
                      backgroundColor: activeTab === 'stores' ? 'white' : '#f8f9fa',
                      color: activeTab === 'stores' ? '#ff7f00' : '#666',
                      borderRadius: '8px 8px 0 0',
                      marginRight: '2px',
                      cursor: 'pointer',
                      fontWeight: activeTab === 'stores' ? 'bold' : 'normal',
                      transition: 'all 0.3s ease',
                      outline: 'none',
                      position: 'relative',
                      zIndex: activeTab === 'stores' ? '2' : '1'
                    }}
                    onMouseEnter={(e) => {
                      if (activeTab !== 'stores') {
                        e.target.style.backgroundColor = '#e9ecef';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (activeTab !== 'stores') {
                        e.target.style.backgroundColor = '#f8f9fa';
                      }
                    }}
                  >
                    Stores
                  </button>
                  <button 
                    onClick={() => setActiveTab('salesperson')}
                    style={{
                      padding: '12px 24px',
                      border: '1px solid #e0e0e0',
                      borderBottom: activeTab === 'salesperson' ? '1px solid white' : '1px solid #e0e0e0',
                      backgroundColor: activeTab === 'salesperson' ? 'white' : '#f8f9fa',
                      color: activeTab === 'salesperson' ? '#ff7f00' : '#666',
                      borderRadius: '8px 8px 0 0',
                      cursor: 'pointer',
                      fontWeight: activeTab === 'salesperson' ? 'bold' : 'normal',
                      transition: 'all 0.3s ease',
                      outline: 'none',
                      position: 'relative',
                      zIndex: activeTab === 'salesperson' ? '2' : '1'
                    }}
                    onMouseEnter={(e) => {
                      if (activeTab !== 'salesperson') {
                        e.target.style.backgroundColor = '#e9ecef';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (activeTab !== 'salesperson') {
                        e.target.style.backgroundColor = '#f8f9fa';
                      }
                    }}
                  >
                    Sales
                  </button>
                </div>
              </div>
              
              {/* Tab Content Container */}
              <div style={{
                border: '1px solid #e0e0e0',
                borderRadius: '0 8px 8px 8px',
                backgroundColor: 'white',
                padding: '20px',
                minHeight: '400px'
              }}>
                {activeTab === 'stores' && <LeaderBoard />}
                {activeTab === 'salesperson' && <SalesLeaderBoard />}
              </div>
            </div>
          </div>
        </div>
    </>
  )
}
